import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTenantCollection } from '../hooks/useTenantData';
import { useClub } from '../contexts/ClubContext';

function Teams() {
  const { club } = useClub();
  
  // Use tenant-scoped data hook
  const { data: tenantTeams, loading } = useTenantCollection('teams');

  // Default team data (fallback if Firestore is empty)
  const defaultTeams = [
    {
      id: 1,
      name: "U18 Tier 1",
      ageGroup: "U18",
      tier: "Tier 1",
      coach: "Coach Michael Roberts",
      assistant: "Coach David James",
      training: "Tue & Thu 5:00 PM",
      players: [
        { id: 1, name: "Kyle Baptiste", position: "Defender", number: 4 },
        { id: 2, name: "Jamal Charles", position: "Midfielder", number: 8 },
        { id: 3, name: "Terrence Phillip", position: "Forward", number: 11 },
        { id: 4, name: "Aaron Joseph", position: "Goalkeeper", number: 1 },
        { id: 5, name: "Brandon Lee", position: "Defender", number: 3 },
        { id: 6, name: "Christopher Adams", position: "Midfielder", number: 6 },
      ]
    },
    {
      id: 2,
      name: "U16 Tier 1",
      ageGroup: "U16",
      tier: "Tier 1",
      coach: "Coach Anthony Wilson",
      assistant: "Coach Mark Taylor",
      training: "Mon & Wed 4:30 PM",
      players: [
        { id: 7, name: "Marcus Johnson", position: "Forward", number: 10 },
        { id: 8, name: "Dillon Murray", position: "Midfielder", number: 7 },
        { id: 9, name: "Kevon Williams", position: "Defender", number: 2 },
        { id: 10, name: "Isaiah Brown", position: "Forward", number: 9 },
        { id: 11, name: "Nathan Scott", position: "Goalkeeper", number: 1 },
        { id: 12, name: "Jordan Alexander", position: "Midfielder", number: 5 },
      ]
    },
    {
      id: 3,
      name: "U16 Tier 2",
      ageGroup: "U16",
      tier: "Tier 2",
      coach: "Coach Steven Paul",
      assistant: "Coach Richard Henry",
      training: "Tue & Thu 4:30 PM",
      players: [
        { id: 13, name: "Daniel Singh", position: "Goalkeeper", number: 1 },
        { id: 14, name: "Aiden Mohammed", position: "Defender", number: 4 },
        { id: 15, name: "Liam Garcia", position: "Midfielder", number: 8 },
        { id: 16, name: "Ethan Peters", position: "Forward", number: 10 },
        { id: 17, name: "Noah Clarke", position: "Defender", number: 3 },
      ]
    },
    {
      id: 4,
      name: "U14 Tier 1",
      ageGroup: "U14",
      tier: "Tier 1",
      coach: "Coach Gregory Thomas",
      assistant: "Coach Paul Edwards",
      training: "Mon & Wed 4:00 PM",
      players: [
        { id: 18, name: "Andre Williams", position: "Midfielder", number: 8 },
        { id: 19, name: "Ryan Mohammed", position: "Midfielder", number: 7 },
        { id: 20, name: "Jayden Lewis", position: "Forward", number: 9 },
        { id: 21, name: "Tyler Joseph", position: "Defender", number: 5 },
        { id: 22, name: "Cameron Baptiste", position: "Goalkeeper", number: 1 },
        { id: 23, name: "Derek Charles", position: "Defender", number: 2 },
      ]
    },
    {
      id: 5,
      name: "U14 Tier 2",
      ageGroup: "U14",
      tier: "Tier 2",
      coach: "Coach Brian Mitchell",
      assistant: "",
      training: "Tue & Thu 4:00 PM",
      players: [
        { id: 24, name: "Justin Rampersad", position: "Forward", number: 11 },
        { id: 25, name: "Shane Ali", position: "Midfielder", number: 6 },
        { id: 26, name: "Marcus Gonzales", position: "Defender", number: 4 },
        { id: 27, name: "Kevin Ramnath", position: "Goalkeeper", number: 1 },
      ]
    },
    {
      id: 6,
      name: "U12 Tier 1",
      ageGroup: "U12",
      tier: "Tier 1",
      coach: "Coach Andrew Francis",
      assistant: "Coach Raymond Lal",
      training: "Sat 9:00 AM",
      players: [
        { id: 28, name: "Joshua Thomas", position: "Forward", number: 9 },
        { id: 29, name: "Matthew James", position: "Midfielder", number: 10 },
        { id: 30, name: "Samuel Pierre", position: "Defender", number: 3 },
        { id: 31, name: "Alexander Moore", position: "Goalkeeper", number: 1 },
        { id: 32, name: "Gabriel Singh", position: "Forward", number: 7 },
      ]
    },
    {
      id: 7,
      name: "U10",
      ageGroup: "U10",
      tier: "",
      coach: "Coach Sandra Williams",
      assistant: "Coach Michelle Brown",
      training: "Sat 10:30 AM",
      players: [
        { id: 33, name: "Elijah Adams", position: "Forward", number: 9 },
        { id: 34, name: "Lucas Martinez", position: "Midfielder", number: 8 },
        { id: 35, name: "Oliver Henry", position: "Defender", number: 4 },
        { id: 36, name: "Benjamin Paul", position: "Goalkeeper", number: 1 },
      ]
    },
    {
      id: 8,
      name: "U8",
      ageGroup: "U8",
      tier: "",
      coach: "Coach Karen Joseph",
      assistant: "",
      training: "Sat 8:00 AM",
      players: [
        { id: 37, name: "Sebastian King", position: "All Positions", number: 7 },
        { id: 38, name: "Theodore Scott", position: "All Positions", number: 10 },
        { id: 39, name: "Harrison Lee", position: "All Positions", number: 3 },
        { id: 40, name: "Zachary Miller", position: "All Positions", number: 5 },
      ]
    }
  ];

  // Use tenant teams if available, otherwise fallback to defaults
  const teams = tenantTeams.length > 0 
    ? tenantTeams.map(t => ({ ...t, players: t.players || t.roster || [] }))
    : defaultTeams;

  const ageGroups = ["All", "U18", "U16", "U14", "U12", "U10", "U8"];
  const [selectedAge, setSelectedAge] = useState("All");
  const [expandedTeam, setExpandedTeam] = useState(null);

  const filteredTeams = selectedAge === "All" 
    ? teams 
    : teams.filter(team => team.ageGroup === selectedAge);

  const toggleTeam = (teamId) => {
    setExpandedTeam(expandedTeam === teamId ? null : teamId);
  };

  const getPositionColor = (position) => {
    switch(position) {
      case "Goalkeeper": return "#f59e0b";
      case "Defender": return "#3b82f6";
      case "Midfielder": return "#10b981";
      case "Forward": return "#ef4444";
      default: return "#9ca3af";
    }
  };

  if (loading) {
    return (
      <div className="teams-page">
        <section className="teams-hero">
          <h1>OUR TEAMS</h1>
          <p>Loading teams...</p>
        </section>
      </div>
    );
  }

  return (
    <div className="teams-page">
      {/* Hero Section */}
      <section className="teams-hero">
        <h1>OUR TEAMS</h1>
        <p>View all {club?.name || 'ClubLink TT'} teams and rosters across age groups</p>
      </section>

      {/* Age Group Filter */}
      <section className="teams-filter">
        <div className="filter-buttons">
          {ageGroups.map((age) => (
            <button
              key={age}
              className={`filter-btn ${selectedAge === age ? 'active' : ''}`}
              onClick={() => setSelectedAge(age)}
            >
              {age}
            </button>
          ))}
        </div>
      </section>

      {/* Teams Grid */}
      <section className="teams-container">
        <div className="teams-grid">
          {filteredTeams.map((team) => (
            <div 
              key={team.id} 
              className={`team-card ${expandedTeam === team.id ? 'expanded' : ''}`}
            >
              <div className="team-header" onClick={() => toggleTeam(team.id)}>
                <div className="team-info">
                  <h2 className="team-name">{team.name}</h2>
                  <div className="team-meta">
                    <span className="team-coach">{team.coach}</span>
                    {team.assistant && <span className="team-assistant">{team.assistant}</span>}
                  </div>
                </div>
                <div className="team-stats">
                  <div className="player-count">
                    <span className="count-number">{team.players.length}</span>
                    <span className="count-label">Players</span>
                  </div>
                  <div className="team-training">
                    <span className="training-icon">📅</span>
                    <span className="training-time">{team.training}</span>
                  </div>
                </div>
                <button className="expand-btn">
                  {expandedTeam === team.id ? '▲' : '▼'}
                </button>
              </div>

              {expandedTeam === team.id && (
                <div className="team-roster">
                  <div className="roster-header">
                    <span className="roster-col">#</span>
                    <span className="roster-col name-col">Player</span>
                    <span className="roster-col">Position</span>
                  </div>
                  {team.players.map((player) => (
                    <div key={player.id} className="roster-row">
                      <span className="player-number">{player.number}</span>
                      <span className="player-name">{player.name}</span>
                      <span 
                        className="player-position-badge"
                        style={{ backgroundColor: getPositionColor(player.position) }}
                      >
                        {player.position}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="teams-stats-section">
        <div className="teams-stats-grid">
          <div className="teams-stat-card">
            <span className="stat-number">{teams.length}</span>
            <span className="stat-label">Total Teams</span>
          </div>
          <div className="teams-stat-card">
            <span className="stat-number">{teams.reduce((acc, team) => acc + team.players.length, 0)}</span>
            <span className="stat-label">Total Players</span>
          </div>
          <div className="teams-stat-card">
            <span className="stat-number">6</span>
            <span className="stat-label">Age Groups</span>
          </div>
          <div className="teams-stat-card">
            <span className="stat-number">12</span>
            <span className="stat-label">Coaches</span>
          </div>
        </div>
      </section>

      {/* Join CTA */}
      <section className="teams-cta">
        <h2>WANT TO JOIN A TEAM?</h2>
        <p>Register now and get placed in the right age group for your development.</p>
        <Link to="/register" className="btn-primary">REGISTER NOW →</Link>
      </section>
    </div>
  );
}

export default Teams;
